const css = `.n8S62W__circle{width:12px;height:12px;border-radius:50%}.n8S62W__outlined{border:2px solid var(--base-strokes-default)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"outlined":"n8S62W__outlined","circle":"n8S62W__circle"};
